export default __webpack_public_path__ + "static/media/404.71c68c55.jpg";